/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_State_InvalidInputs */



/**
* | output |
* | --- |
* | "Invalid" |
*
* @param {Table_State_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const table_state_invalid = /** @type {((inputs?: Table_State_InvalidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_State_InvalidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inválido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inválido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non valido")
	return /** @type {LocalizedString} */ ("Invalid")
});